export default {"src":"/_next/static/media/SHP.f2a94711.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};